import React, { useState } from "react";
import { connect } from "react-redux";
import ButtonWithText from "app/popleads/components/ui-kit/Button";

function ButtonComponent() {
    const [count, setCount] = useState(0);

    return (
        <div className="card card-custom mt-5">
            <div className="card-header">
                <h3 className="card-title">Button</h3>
            </div>
            <div className="card-body">
                <h4>Primary Button</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="primary" type="default" onClick={() => setCount(count + 1)}>
                        Primary Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="default"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Primary Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="default"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Primary Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="default"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Primary Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="default"
                        icon={"delete"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="default"
                        icon={"delete"}
                        iconType={"material"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Primary Button Inverted</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="primary" type="inverted" onClick={() => setCount(count + 1)}>
                        Primary Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="inverted"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Primary Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="inverted"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Primary Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="inverted"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Primary Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="inverted"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Primary Button Borderless</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="primary" type="borderless" onClick={() => setCount(count + 1)}>
                        Primary Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="borderless"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Primary Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="borderless"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Primary Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="borderless"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Primary Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="primary"
                        type="borderless"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Success Button</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="success" type="default" onClick={() => setCount(count + 1)}>
                        Success Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="default"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Success Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="default"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Success Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="default"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Success Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="default"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Success Button Inverted</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="success" type="inverted" onClick={() => setCount(count + 1)}>
                        Success Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="inverted"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Success Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="inverted"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Success Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="inverted"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Success Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="inverted"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Success Button Borderless</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="success" type="borderless" onClick={() => setCount(count + 1)}>
                        Success Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="borderless"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Success Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="borderless"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Success Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="borderless"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Success Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="success"
                        type="borderless"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Danger Button</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="danger" type="default" onClick={() => setCount(count + 1)}>
                        Danger Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="default"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Danger Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="default"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Danger Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="default"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Danger Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="default"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Danger Button Inverted</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="danger" type="inverted" onClick={() => setCount(count + 1)}>
                        Danger Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="inverted"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Danger Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="inverted"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Danger Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="inverted"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Danger Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="inverted"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Danger Button Borderless</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="danger" type="borderless" onClick={() => setCount(count + 1)}>
                        Danger Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="borderless"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Danger Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="borderless"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Danger Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="borderless"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Danger Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="danger"
                        type="borderless"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Warning Button</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="warning" type="default" onClick={() => setCount(count + 1)}>
                        Warning Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="default"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Warning Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="default"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Warning Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="default"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Warning Button
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="default"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Warning Button Inverted</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="warning" type="inverted" onClick={() => setCount(count + 1)}>
                        Warning Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="inverted"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Warning Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="inverted"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Warning Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="inverted"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Warning Button Inverted
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="inverted"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <h4>Warning Button Borderless</h4>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                    <ButtonWithText variant="warning" type="borderless" onClick={() => setCount(count + 1)}>
                        Warning Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="borderless"
                        leftIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Warning Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="borderless"
                        rightIcon={"check"}
                        onClick={() => setCount(count + 1)}
                    >
                        Warning Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="borderless"
                        leftIcon={"check"}
                        rightIcon={"x"}
                        onClick={() => setCount(count + 1)}
                    >
                        Warning Button Borderless
                    </ButtonWithText>
                    <ButtonWithText
                        variant="warning"
                        type="borderless"
                        icon={"check"}
                        onClick={() => setCount(count + 1)}
                    ></ButtonWithText>
                </div>

                <div>
                    <p>Click Count: {count}</p>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ButtonComponent);
